<template>
  <div class="sheet">
    <event-time class="event-time" />

    <div class="sheet-base">
      <sheet-row
        v-for="(suit, i) in $store.state.quiz.quizzes"
        :key="i"
        :suit="suit"
        :index="i"
        />
    </div>

    <button-submit-answer />
  </div>
</template>

<script>
import SheetRow from '@/components/Answer/Sheet/Row'
import EventTime from '@/components/Answer/EventTime'
import ButtonSubmitAnswer from '@/components/Answer/ButtonSubmitAnswer'

export default {
  components: {
    SheetRow,
    EventTime,
    ButtonSubmitAnswer
  },

  created: function () {
    if (!this.$store.state.quiz.init) {
      this.$store.commit('quiz/initQuizzes')
      this.$store.commit('quiz/setInit')
    }
    this.$store.dispatch('quiz/fetchFoundQuizzes')
  }
}
</script>

<style lang="scss" scoped>
.event-time {
  margin-bottom: 20px;
}

.sheet {
  padding: 15px;

  &-base {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
